exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.reservationBox[data-v-918a0c92] {\n  box-sizing: border-box;\n\n  background-color: white;\n  border-style: solid;\n  border-color: #0065B3;\n  position: absolute;\n  z-index: 999;\n  overflow: hidden;\n}\n.reservationBox[data-v-918a0c92]:hover {\n  overflow: visible;\n}\n.editButton[data-v-918a0c92] {\n  box-sizing: border-box;\n  background-color: white;\n  border-style: solid;\n  border-color: none;\n  display: inline;\n}\n.trial[data-v-918a0c92], .firstTime[data-v-918a0c92] {\n  background-color: #ddddff;\n}\n.grayedOut[data-v-918a0c92] {\n  border-color: #888888;\n  color: #888888;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-918a0c92","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/ReservationBox.vue
// module id = 539
// module chunks = 0